import {createSlice} from '@reduxjs/toolkit'

const selectionModeSlice = createSlice({
    name: 'selectionMode',
    initialState: false,
    reducers: {
        setMode(_, {payload}) {
            return payload
        }
    }
})

export const selectionModeSelect = (state) => state.selectionMode

export const {setMode} = selectionModeSlice.actions

export default selectionModeSlice.reducer